// Imports => React
import React, {useMemo, memo} from 'react';
import {Props} from './ac-grid-container.proptypes';
import clsx from 'clsx';

const _CLASSES = {
  MAIN: 'ac-container',
  FLUID: 'ac-container--fluid',
  GROW: 'ac-container--grow',
  FLEX: 'ac-container--flex',
};

// Component
const AcContainer = memo<any>(
  ({rel = 'ac-container', fluid, grow, flex, className, children, ...rest}) => {
    const getStyleClassNames = useMemo(() => {
      return clsx(
        !fluid && _CLASSES.MAIN,
        fluid && _CLASSES.FLUID,
        grow && _CLASSES.GROW,
        flex && _CLASSES.FLEX,
        className
      );
    }, [fluid, grow, flex, className]);

    return (
      <div className={getStyleClassNames} rel={rel} {...rest}>
        {children}
      </div>
    );
  }
);

AcContainer.displayName = 'AcContainer';
AcContainer.propTypes = Props;

export {AcContainer};
export default AcContainer;
